import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { API } from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class Util {
  constructor(private translate: TranslateService) { }

  static pathImagemApi(nome: string): string {
    if (nome == null || nome == undefined || nome.length == 0) {
      return `/assets/img/notfound.jpg`;
    } else {
      return `${API}${nome}`;
    }

  }

  fazerTraducao(texto: string): string {
    try {
      return this.translate.instant(texto);
    } catch (e) {
      console.log(e);
      return texto;
    }
  }

  errorHandler(erro, acao: string = null): string {
    let mensagem = "Erro";
    if (acao) {
      mensagem += " ao tentar " + acao + ": ";
    }
    switch (erro.status) {
      case 0:
        mensagem += "o servidor não respondeu, tente novamente mais tarde!";
        break;
      case 401:
        mensagem += "você não tem autorização para executar esta ação!";
        break;
      case 400:
        if (erro.error.mensagens?.length > 0)
          mensagem += erro.error.mensagens.map(m => m).join(", ");
        break;
      case 404:
        mensagem += erro.error.mensagem;
        break;
      case 406:
        mensagem += `a requisição não foi aceita, tente novamente! ${erro.error.mensagem}`;
        break;
      case 500:
        mensagem +=
          "Houve um erro interno no servidor! tente novamente, caso o erro persista, entre em contato com o suporte";
        break;
      default:
        mensagem += erro.statusText;
    }

    return mensagem;
  }

  getEnumLabel<T extends Record<string, string | number>>(enumObj: T, value: number | string): string {
    const key = Object.keys(enumObj).find(k => enumObj[k as keyof T] === value);

    if (!key) return "Desconhecido";

    return key
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  }
}
